/**
 * P4 — Mesh repair API client.
 * Analyzes and repairs STL files for printability.
 */
import apiClient from "./client";

export interface MeshAnalysis {
  status: "PASS" | "ISSUES" | "ERROR";
  fixes_applied: string[];
  before_faces: number | null;
  after_faces: number | null;
  before_watertight: boolean | null;
  after_watertight: boolean | null;
  issues_before: string[];
  issues_after: string[];
  message: string;
}

export interface MeshRepairResult {
  status: "REPAIRED" | "PASS" | "NEEDS_HUMAN" | "ERROR";
  issues_found: string[];
  fixes_applied: string[];
  metrics_before: { faces: number; is_manifold: boolean };
  metrics_after: { faces: number; is_manifold: boolean };
  message: string;
}

/** Analyze a model for printability issues (by provider+task_id). */
export async function analyzeMesh(
  provider: string,
  task_id: string,
): Promise<MeshAnalysis> {
  const resp = await apiClient.post<MeshAnalysis>("/mesh-repair/analyze-model", {
    provider,
    task_id,
  });
  return resp.data;
}

/** Repair a model and return the result. */
export async function repairMesh(
  provider: string,
  task_id: string,
): Promise<MeshRepairResult> {
  const resp = await apiClient.post<MeshRepairResult>("/mesh-repair/repair", {
    provider,
    task_id,
  });
  return resp.data;
}